import { styled } from '@mui/system';

export const Wrapper = styled('div')<{ hasTldr: boolean }>`
  grid-area: tldr;
  display: ${({ hasTldr }) => (hasTldr ? 'block' : 'none')};
`;
